<div [ngClass]="getNotificationContainerClass()">
  @for (notification of notifications; track notification.id) {
    <div class="notification" [ngClass]="className(notification) + ' ' + ((notification.message?.length ?? 0) < 1 ? 'notification-title-only' : '')">
      <div class="notification-content">
        <div class="notification-icon">
          <i [name]="getNotificationIcon(notification).icon" [size]="16" [color]="'#fff'" Icons></i>
        </div>
        <div class="notification-body">
          @if (notification && notification.message && notification.message.length) {
            <div class="notification-title">{{ notification.title }}</div>
            <div class="notification-message">
              @for (messageE of notification.message; track messageE) {
                <div class="message-line">{{ messageE }}</div>
              }
            </div>
          } @else {
            <div class="notification-title-only">{{ notification.title }}</div>
          }
        </div>
        <button class="notification-close" (click)="close(notification)">
          <i [name]="'cross'" [size]="12" [color]="'#fff'" Icons></i>
        </button>
      </div>
    </div>
  }
</div>
